import React, { useState, useEffect } from 'react';
import { ImageBuilder } from "../../global/image-builder";
import { cn } from '../../../lib/helpers';

const PHRASES = [
  "Evaluating quiz",
  "Researching company",
  "Preparing storyline",
  "Personalizing insights",
  "Charting journey",
  "Maxing relevance",
  "Summoning hero squad",
  "Using AI superpowers",
  "Unleashing greatness",
  "Activating pipeline",
  "Crafting destiny",
  "Harnessing the future",
  "Igniting potential",
  "Shaping success",
  "Building momentum",
];

const POWER_ICONS = [
  { icon: "power-icon-sight.svg", color: "#004C77" },  // Oracle - blue
  { icon: "power-icon-speed.svg", color: "#098082" },  // Striker - teal
  { icon: "power-icon-message.svg", color: "#93440D" } // Resonator - orange
];

export const QuizLoading = ({ skipWrapper }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentIconIndex, setCurrentIconIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [iconVisible, setIconVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const cyclePhrase = () => {
      // Fade out
      setIsVisible(false);

      // After fade out (500ms), change phrase and fade in
      setTimeout(() => {
        setCurrentPhraseIndex((prev) => (prev + 1) % PHRASES.length);
        setIsVisible(true);
      }, 500);
    };

    // Cycle through phrases every 5 seconds
    const interval = setInterval(cyclePhrase, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const cycleIcon = () => {
      // Fade out icon
      setIconVisible(false);

      // After fade out (500ms), change icon and fade in
      setTimeout(() => {
        setCurrentIconIndex((prev) => (prev + 1) % POWER_ICONS.length);
        setIconVisible(true);
      }, 500);
    };

    // Cycle through power icons every 8 seconds
    const iconInterval = setInterval(cycleIcon, 8000);

    return () => clearInterval(iconInterval);
  }, []);

  useEffect(() => {
    // Progress bar animation - 60 seconds to reach 100%
    const duration = 60000; // 60 seconds
    const intervalTime = 100; // Update every 100ms
    const increment = (100 / duration) * intervalTime;

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment;
        return next >= 100 ? 100 : next;
      });
    }, intervalTime);

    return () => clearInterval(progressInterval);
  }, []);

  return (
    <div
      className={cn(
        "font-superhero tracking-wider text-white",
        skipWrapper ? "" : "max-w-4xl mx-auto bg-gray-1000 rounded-2xl p-6 border-4 border-dark-80  transition-all duration-300",
      )}
      style={!skipWrapper ? { boxShadow: `0 0 40px ${POWER_ICONS[currentIconIndex].color}` } : {}}
    >
      <div className="text-center py-12">
        {/* Spinner with icon and pulse animation */}
        <style>{`
          @keyframes pulse-scale {
            0%, 100% { transform: scale(0.95); }
            50% { transform: scale(1.1); }
          }
          .pulse-spinner {
            animation: pulse-scale 3s ease-in-out infinite;
          }
        `}</style>
        <div className="relative inline-flex items-center justify-center mb-12 pulse-spinner">
          <div className="animate-spin rounded-full h-36 w-36 border-b-2 border-green-emerald"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <ImageBuilder
              src={`/img/quiz/${POWER_ICONS[currentIconIndex].icon}`}
              alt="Power icon"
              className="w-20 h-20 transition-opacity duration-500"
              style={{
                opacity: iconVisible ? 1 : 0,
              }}
            />
          </div>
        </div>
        <div className="relative h-6 flex items-center justify-center">
          <p
            className="uppercase italic text-5xl transition-all duration-500 ease-in-out"
            style={{
              opacity: isVisible ? 1 : 0,
            }}
          >
            {PHRASES[currentPhraseIndex]}
          </p>
        </div>

        {/* Progress bar */}
        <div className="mt-12 max-w-2xl mx-auto">
          <div className="relative w-full h-2 bg-dark-50 rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full rounded-full transition-all duration-100 ease-linear"
              style={{
                width: `${progress}%`,
                background: `linear-gradient(90deg, ${POWER_ICONS[0].color}, ${POWER_ICONS[1].color}, ${POWER_ICONS[2].color})`,
                boxShadow: `0 0 20px ${POWER_ICONS[currentIconIndex].color}80`
              }}
            />
          </div>
        </div>
      </div>
    </div>

  );
};
